import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import {
  DeleteProduct,
  DeleteProductSuccess,
  GetProductById,
  GetProductByIdError,
  GetProductByIdSuccess,
  ImproveVariantsProduct,
  ImproveVariantsProductSuccess,
  UpdateProduct,
  UpdateProductSuccess,
  UpdateVariantsProduct,
} from '../../store/produits.actions';
import { Subscription, take, tap } from 'rxjs';
import { ICurrencyPrice, IFile, IProduct, IVariant } from '../../models/products.models';
import { SetCurrentElementId } from 'src/app/shared/store/shared.actions';
import { ICatalog } from 'src/app/features/catalogs/models/catalogs.models';
import { EditProductPricingComponent } from '../edit-product-pricing/edit-product-pricing.component';
import { EditProductInventoryComponent } from '../edit-product-inventory/edit-product-inventory.component';
import { EditProductVariantsComponent } from '../edit-product-variants/edit-product-variants.component';
import { EditBasicProductInfoComponent } from '../edit-basic-product-info/edit-basic-product-info.component';
import { EditProductOrganizeComponent } from '../edit-product-organize/edit-product-organize.component';
import {
  FetchAllBrands,
} from 'src/app/features/brands/store/brands.actions';
import {
  FetchAllTags,
} from 'src/app/features/tags/store/tags.actions';
import {
  FetchAllCategories,
} from 'src/app/features/categories/store/categories.actions';
import {
  FetchAllCatalogs,
} from 'src/app/features/catalogs/store/catalogs.actions';
import { EditFilesComponent } from '../edit-files/edit-files.component';
import { ConfirmationPopUpComponent } from 'src/app/shared/confirmation-pop-up/confirmation-pop-up.component';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/shared/common.service';
import { environment } from 'src/environments/environment';
import { FilesDialogPreviewerComponent } from 'src/app/shared/files-dialog-previewer/files-dialog-previewer.component';
import { ICurrency } from 'src/app/features/customers/models/customers.models';
import { LocalStorageService } from 'src/app/shared/localstorage.service';
import { DetailsDialogueProductComponent } from '../../components/details-dialog-product/details-dialogue-product.component';
import { productStatusI18nKey, productStatusTone } from '../../utils/product-status';
import { StatusBadgeTone } from 'src/app/ui/status-badge/status-badge.component';
@Component({
  selector: 'app-details-product',
  templateUrl: './details-product.component.html',
  styleUrls: ['./details-product.component.scss'],
})
export class DetailsProductComponent implements OnInit {
  product!: IProduct;
  produitId!: number;
  selectedCatalogs: ICatalog[] = [];
  productType!: string;
  currentForm: string = 'addProduct';
  private subscriptions: Subscription[] = [];
  selectedValues: { [key: string]: string } = {};
  selectedVariant: IVariant | undefined = undefined;
  selectedFiles: IFile[] = [];
  areNotCatalogsUpdated: boolean = false;
  timestamp = new Date().getTime();
  defaultImage?: string;
  apiBaseUrl = environment.BASE_URL_API;
  salesPrices: ICurrencyPrice[] = []
  costPrices: ICurrencyPrice[] = []
  defaultCurrency: ICurrency | undefined = LocalStorageService.get('currentUser')?.user?.currency!;

  activeTab: 'insights' | 'inventory_tab' | 'catalogs' = 'insights';

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private store: Store<AppState>,
    private actions$: Actions,
    private route: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.produitId = +this.route.snapshot.paramMap.get('id')!;
    if (this.produitId) {
      this.store.dispatch(
        SetCurrentElementId({ currentElementId: this.produitId })
      );
      this.store.dispatch(GetProductById({ id: this.produitId }));
      this.store.dispatch(FetchAllBrands({}));
      this.store.dispatch(FetchAllTags({}));
      this.store.dispatch(FetchAllCategories({}));
      this.store.dispatch(FetchAllCatalogs());
    }
    const sub1 = this.actions$
      .pipe(
        ofType(GetProductByIdSuccess),
        tap((action) => {
          this.product = {
            ...action.product,
            codes: Object.entries(action.product?.code_identifiers || {}).map(
              ([key, value]) => ({
                label: key,
                value: value,
              })
            ),
            variants: action.product.variants?.map((variant: IVariant) => {
              return {
                ...variant,
                codes: Object.entries(variant.code_identifiers || {}).map(
                  ([key, value]) => ({
                    label: key,
                    value: value,
                  })
                ),
              };
            }),
          };
          this.selectedFiles = action.product?.files || [];

          this.defaultImage = this.product.image;

          if (
            action.product.variants &&
            action.product.variants.length > 0 &&
            action.product.attributes &&
            action.product.attributes.length > 0
          ) {
            this.productType = 'variante';
            action.product.attributes!.forEach((attribute) => {
              this.selectedValues[attribute.name] = attribute.values[0];
            });
            this.updateSelectedVariant();
          } else {
            this.productType = 'standard';
            this.salesPrices = this.product.currency_prices?.filter(price => price.type == 'retail_price') ?? []
            this.costPrices = this.product.currency_prices?.filter(price => price.type == 'cost') ?? []
          }
          if (action.product.catalogs && action.product.catalogs.length > 0) {
            this.selectedCatalogs = action.product?.catalogs!.map(
              (catalog: ICatalog) => {
                return {
                  ...catalog,
                };
              }
            );
          }
        })
      )
      .subscribe();

    const sub2 = this.actions$
      .pipe(
        ofType(
          GetProductByIdError,
          DeleteProductSuccess
          // ImproveVariantsProductSuccess
        ),
        tap(() => {
          this.cancel(true);
        })
      )
      .subscribe();

    const sub3 = this.actions$.pipe(
      ofType(ImproveVariantsProductSuccess, UpdateProductSuccess),
      tap(() => {
        this.store.dispatch(GetProductById({ id: this.produitId }));
      })).subscribe();

    this.subscriptions.push(sub1, sub2, sub3);
  }

  getDefaultImage() {
    return this.defaultImage?.includes('cdn/') ? this.apiBaseUrl + this.defaultImage : `data:'';base64, ${this.defaultImage}`
  }

  getImages(): string[] {
    return this.product.images ? this.product.images.map((image: any) => {
      if(typeof image === 'string')
        return this.apiBaseUrl + image
      else if(!image.isDefault)
        return image.preview
      else
        return "";
    }).filter((image: string) => image != "") : [];
  }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/icones/default-image-product.svg';
  }

  selectAttributeValue(attribute: string, value: string): void {
    this.selectedValues[attribute] = value;
    this.updateSelectedVariant();
  }

  isSelected(attribute: string, value: string): boolean {
    return this.selectedValues[attribute] === value;
  }

  updateSelectedVariant(): void {
    const selectedAttributes = Object.values(this.selectedValues);
    this.selectedVariant = this.product.variants?.find((variant) =>
      selectedAttributes.every((val) => variant.values.includes(val))
    );
    this.salesPrices = this.selectedVariant?.currency_prices?.filter(price => price.type == 'retail_price') ?? []
    this.costPrices = this.selectedVariant?.currency_prices?.filter(price => price.type == 'cost') ?? []
  }

  editBasicInfo() {
    const dialogRef = this.dialog.open(EditBasicProductInfoComponent, {
      data: {
        image: this.product.image,
        images: this.product.images ? this.product.images : [],
        name: this.product.name,
        status: this.product.status,
        description: this.product.description,
        brandControl: this.product.brand?.name,
        brand_id: this.product.brand_id,
        brand: this.product.brand,
        productType: this.productType,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.product = {
          ...this.product,
          name: result.name,
          status: result.status,
          description: result.description,
          brand: result.brand,
        };

        if(result.images) {
          this.product = {
            ...this.product,
            images: result.images
          }
        }

        this.save();
      }
    });
  }

  editPricingProduct() {
    const dialogRef = this.dialog.open(EditProductPricingComponent, {
      data: {
        sales_price: this.product.sales_price,
        cost: this.product.cost,
        currencyPrices: this.product.currency_prices,
        default_currency: this.product.default_currency
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.product = {
          ...this.product,
          sales_price: result.sales_price,
          cost: result.cost,
          currency_prices: result.currency_prices
        };

        this.save();
      }
    });
  }

  editInventoryProduct() {
    type Code = { label: string; value: string };
    const dialogRef = this.dialog.open(EditProductInventoryComponent, {
      data: {
        sku: this.product.sku,
        barcodeControl: this.product.barcode,
        quantity: this.product.stock?.quantity,
        reorder_point: this.product.stock?.reorder_point,
        reorder_quantity: this.product.stock?.reorder_quantity,
        codes: this.product.codes,
        expiry_date: this.product.expiry_date,
        translate: this.translateService,
        max_qte: this.product.variants?.[0]?.max_qte,
        min_qte: this.product.variants?.[0]?.min_qte,
        increment: this.product.variants?.[0]?.increment
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.product = {
          ...this.product,
          sku: result.sku,
          barcode: result.barcodeControl,
          expiry_date: result.expiry_date,
          stock: {
            quantity: result.quantity,
            reorder_point: result.reorder_point,
            reorder_quantity: result.reorder_quantity,
          },
          code_identifiers: result.codes.reduce(
            (acc: Record<string, string>, { label, value }: Code) => {
              acc[label] = value;
              return acc;
            },
            {}
          ),
          codes: result.codes,
          max_qte: result.max_qte,
          min_qte: result.min_qte,
          increment: result.increment
        };

        this.save();
      }
    });
  }

  editOrganizeProduct() {
    const dialogRef = this.dialog.open(EditProductOrganizeComponent, {
      data: {
        //categoryControl: this.product.category?.name,
        tags: this.product.tags,
        //category_id: this.product.category?.id,
        categories: this.product.categories,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.product = {
          ...this.product,
          categories: result.categories,
          tags: result.tags,
        };

        this.save();
      }
    });
  }

  editVariantProduct() {
    const variants = this.product.variants?.map((variant: IVariant) => {
      return {
        ...variant,
        codes: Object.entries(variant.code_identifiers || {}).map(
          ([key, value]) => ({
            label: key,
            value: value,
          })
        ),
      };
    });
    const dialogRef = this.dialog.open(EditProductVariantsComponent, {
      data: {
        variants: variants,
        attributes: this.product.attributes,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.product = {
          ...this.product,
          variants: result.variants,
        };
        this.updateSelectedVariant();

        this.save();
      }
    });
  }

  goTo(form: string) {
    this.currentForm = form;
  }

  onSaveCatalogs(selectedCatalogs: ICatalog[]) {
    this.selectedCatalogs = selectedCatalogs;
    this.currentForm = 'addProduct';
    this.save();
  }

  async save() {
    const check1 =
      this.selectedCatalogs.length === this.product.catalogs?.length;
    const check2 = this.selectedCatalogs.every((catalog) =>
      this.product.catalogs?.some(
        (prodCatalog) => prodCatalog.id === catalog.id
      )
    );
    this.areNotCatalogsUpdated = check1 && check2;

    const payload: any = {
      name: this.product.name,
      sku: this.product.sku,
      description: this.product.description,
      status: this.product.status,
      cost: this.product.cost,
      sales_price: this.product.sales_price,
      barcode: this.product.barcode,
      tag_ids: this.product.tags!.map((tag) => tag.id),
      category_ids: this.product.categories!.map((category) => category.id),
      brand_id: this.product.brand?.id || 0,
      stock: this.product.stock,
      expiry_date: this.product.expiry_date,
      files: this.selectedFiles,
      data_source: this.product.data_source,
      max_qte: this.product.max_qte,
      min_qte: this.product.min_qte,
      increment: this.product.increment,
      ...(this.productType !== 'variante'
        ? { code_identifiers: this.product.code_identifiers }
        : {}),
      ...(!this.areNotCatalogsUpdated
        ? { catalog_ids: this.selectedCatalogs.map((catalog) => catalog.id) }
        : {})
    };

    this.defaultImage = undefined;

    // transform existing images to base64
    if(this.product.images.filter((image: any) => typeof image !== 'string').length) {
      const existingImagesToBase64 = await this.convertImagesToBase64(this.product.images)

      const parsedImages = existingImagesToBase64 ? existingImagesToBase64.map((img: any) => {
        return { image: img.preview.split(',')[1], default: img.isDefault }
      }) : []

      payload.images = parsedImages;

      this.defaultImage = payload.images.find((image: any) => image.default).image;
    }

    // this is used to delete product images
    if(this.product.images.length === 0) {
      payload.images = []
    }

    if (this.productType === 'variante') {
      if (this.product.variants && this.product.variants.length > 0) {
        const variants = this.product.variants.map((variant: IVariant) => {
          const payload: any = {
            id: variant.id,
            sku: variant.sku,
            barcode: variant.barcode,
            cost: variant.cost,
            sales_price: variant.sales_price,
            expiry_date: variant.expiry_date,
            enabled: variant.enabled,
            max_qte: variant.max_qte,
            min_qte: variant.min_qte,
            increment: variant.increment,
            currency_prices: variant.currency_prices,
            stock: {
              quantity: variant.stock!.quantity,
              reorder_point: variant.stock!.reorder_point,
              reorder_quantity: variant.stock!.reorder_quantity,
            },
            code_identifiers: variant.code_identifiers,
          };

          if(variant.image && !variant.image.includes('.jpg') || variant.image === '') {
            payload.image = variant.image
          }

          return payload
        });
        this.store.dispatch(
          ImproveVariantsProduct({
            variants: variants,
            idProduct: this.product.id!,
            product: payload,
          })
        );
      } else {
        this.commonService.showToast(
          this.translateService.instant('inventory.alert_generate_variants'),
          'WARNING'
        );
        return;
      }
    } else {
      payload.currency_prices = this.product.currency_prices;
      this.store.dispatch(
        UpdateProduct({ id: this.product.id, product: payload })
      );
    }
  }

  convertImagesToBase64(images: any[]): Promise<any[]> {
    const promises = images.map(async (image) => {
      if (!image.preview.startsWith('data:')) {
        image.preview = await this.getBase64ImageFromUrlUsingCanvas(this.apiBaseUrl + image.preview)
        // .catch(() => image.preview); // If conversion fails, keep the original URL
      }
      return image;
    });

    return Promise.all(promises);
  }

  async getBase64ImageFromUrlUsingCanvas(imageUrl: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous'; // Use if the server supports CORS
      img.src = imageUrl;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');

        if (ctx) {
          ctx.drawImage(img, 0, 0);
          const base64 = canvas.toDataURL('image/png')
          resolve(base64); // Convert to Base64
        } else {
          reject('Canvas not supported');
        }
      };

      img.onerror = () => reject('Failed to load image');
    });
  }

  deleteProduct() {
    const dialogRef = this.dialog.open(ConfirmationPopUpComponent, {
      data: {
        icon: '../../../assets/icones/cancel_alert.svg',
        confirm_text: this.translateService.instant('common.remove'),
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        const deleteSuccessSub = this.actions$.pipe(
          ofType(DeleteProductSuccess),
          take(1)
        ).subscribe(() => {
          // this.router.navigate(['inventory'], {
          //   queryParamsHandling: 'preserve'
          // });
          deleteSuccessSub.unsubscribe();
        });
        this.store.dispatch(DeleteProduct({ id: this.product.id }));
      }
    });
  }

  editFiles(files: IFile[] = []): void {
    const dialogRef = this.dialog.open(EditFilesComponent, {
      data: { files },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result: IFile[]) => {
      if (result) {
        this.selectedFiles = [...result];
        this.save();
      }
    });
  }

  canceled() {
    this.currentForm = 'addProduct';
  }

  cancel(keepParams = true) {
    this.router.navigate(['inventory'], {
      queryParamsHandling: keepParams ? 'merge': ''
    });
  }

  viewDetails() {
    this.dialog.open(DetailsDialogueProductComponent, {
      data: this.product,
    });
  }

  private convertBase64ToBlob(data: string, content_type: string): Blob {
    const byteCharacters = atob(data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(0)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: content_type });
  }

  download(data: string, fileName: string, content_type: string) {
    const blob = this.convertBase64ToBlob(data, content_type);
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
  }
  preview(data: string, content_type: string) {
    const blob = this.convertBase64ToBlob(data, content_type);
    this.dialog.open(FilesDialogPreviewerComponent, {
      data: [blob]
    })
  }
  public getStatusTranslation(status: string): string {
    return this.translateService.instant(productStatusI18nKey(status)) || status;
  }

  public statusTone(product: IProduct): StatusBadgeTone {
    return productStatusTone(product.status);
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
